import { Box, Paper, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import ProductAddonForm from "../../components/crm/ProductAddonForm";
import { useBreadcrumbs } from "../../contexts/BreadcrumbContext";
import { useSnackbar } from "../../contexts/SnackbarContext";
import { createAdminProductAddon } from "../../services/order.service";
import { ProductAddonCreateRequest } from "../../types/order";

export default function CrmAddonsCreate() {
  const navigate = useNavigate();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Add-on List", to: "/crm/addons" },
      { label: "Create Add On", to: "/crm/addons/create" },
    ]);
  }, [setBreadcrumbs]);

  const handleSubmit = async (data: ProductAddonCreateRequest) => {
    try {
      await createAdminProductAddon(data);
      showSnackbar("Add-on created successfully", "success");
      navigate("/crm/addons");
    } catch (error) {
      console.error("Error creating add-on:", error);
      showSnackbar("Failed to create add-on", "error");
    }
  };

  return (
    <Stack spacing={3}>
      <Box>
        <Paper sx={{ borderRadius: 1, overflow: "hidden" }}>
          <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid #D8DBDF" }}>
            <Typography sx={{ fontSize: 20, fontWeight: 600, lineHeight: 1.4 }}>
              Add-on Info
            </Typography>
          </Box>

          <Box sx={{ p: 2 }}>
            <ProductAddonForm
              onSubmit={handleSubmit as any}
              onCancel={() => navigate("/crm/addons")}
            />
          </Box>
        </Paper>
      </Box>
    </Stack>
  );
}
